/* 歌单分组工具函数 */

// 拼音分组常量
const PINYIN_ANCHORS = [
  ['A', '阿'], ['B', '八'], ['C', '擦'], ['D', '大'], ['E', '饿'],
  ['F', '发'], ['G', '嘎'], ['H', '哈'], ['J', '击'], ['K', '卡'],
  ['L', '拉'], ['M', '妈'], ['N', '拿'], ['O', '哦'], ['P', '怕'],
  ['Q', '七'], ['R', '然'], ['S', '撒'], ['T', '他'], ['W', '挖'],
  ['X', '西'], ['Y', '压'], ['Z', '杂'],
];
const CJK_RE = /[\u3400-\u9fff\uf900-\ufaff]/;
const pinyinCollator = new Intl.Collator('zh-Hans-CN-u-co-pinyin');

export function splitTags(str) {
  if (!str) return [];
  return str.split(/[,，、\/]+/).map((t) => t.trim()).filter(Boolean);
}

export function sortSongsByPinyin(songs) {
  return [...(songs || [])].sort((a, b) => a.title.localeCompare(b.title, 'zh-Hans-CN-u-co-pinyin'));
}

export function hasNote(song) {
  return !!(song.note && song.note.trim());
}

export function sortSongsForDisplay(songs) {
  const list = songs || [];
  const noted = sortSongsByPinyin(list.filter(hasNote));
  const unnoted = sortSongsByPinyin(list.filter((s) => !hasNote(s)));
  return [...noted, ...unnoted];
}

export function letterForTitle(title) {
  if (!title) return '#';
  const first = title.trim().charAt(0);
  if (!first) return '#';
  if (!CJK_RE.test(first)) return first.toUpperCase();
  let lo = 0, hi = PINYIN_ANCHORS.length;
  while (lo < hi) {
    const mid = (lo + hi) >>> 1;
    if (pinyinCollator.compare(first, PINYIN_ANCHORS[mid][1]) >= 0) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }
  return lo > 0 ? PINYIN_ANCHORS[lo - 1][0] : '#';
}

export function buildLetterGroups(songs) {
  const groups = [];
  (songs || []).forEach((song, idx) => {
    const letter = letterForTitle(song.title);
    const last = groups[groups.length - 1];
    if (last && last.letter === letter) {
      last.end = idx + 1;
    } else {
      groups.push({ letter: letter, start: idx, end: idx + 1 });
    }
  });
  return groups;
}

export function splitMultiValue(raw) {
  return (raw || '').split(/[、，,/]+/).map((s) => s.trim()).filter(Boolean);
}

export function buildFieldGroups(songs, field, fallbackLabel) {
  const map = new Map();
  (songs || []).forEach((song) => {
    const values = splitTags(song[field]);
    const labels = values.length ? values : [fallbackLabel];
    labels.forEach((label) => {
      if (!map.has(label)) map.set(label, []);
      map.get(label).push(song);
    });
  });
  const labels = [...map.keys()].sort((a, b) => {
    if (a === fallbackLabel) return b === fallbackLabel ? 0 : 1;
    if (b === fallbackLabel) return -1;
    return pinyinCollator.compare(a, b);
  });
  return labels.map((label) => ({ label: label, songs: sortSongsByPinyin(map.get(label)) }));
}

export function groupSongsForView(songs, mode) {
  let groups;
  if (mode === 'genre') groups = buildFieldGroups(songs, 'genre', '未分类曲风');
  else if (mode === 'singer') groups = buildFieldGroups(songs, 'originalSinger', '未分类歌手');
  else groups = buildLetterGroups(songs).map((g) => {
      return { label: g.letter, songs: songs.slice(g.start, g.end) };
    });
  let idx = 0;
  groups = groups.map((g) => ({
    label: g.label,
    songs: g.songs.map((s) => ({ ...s, _index: ++idx})),
  }));
  return groups;
}